import { createFilterOptions } from "@mui/material";
import type { ClusterRunResponse } from "src/queries/compute/compute.types";

export const SLOT_PROPS = {
  listbox: { sx: { maxHeight: 500 } },
  paper: {
    "data-test-id": "run-time-selector-paper",
    sx: {
      width: "max-content",
      minWidth: "100%",
    },
  },
};

const MAX_RUNS = 100;

export const filterOptions = createFilterOptions<ClusterRunResponse>({
  ignoreCase: true,
  matchFrom: "any",
  limit: MAX_RUNS,
});
